import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button, TextInput } from '@any-ui-react/core';
import classNames from 'classnames';

interface NoteFormValues {
  note: string;
}

interface NoteFormProps {
  onSubmit?: (text: string) => Promise<boolean>;
  variant?: 'floating' | 'inline';
}

export const NoteForm = ({ onSubmit, variant = 'floating' }: NoteFormProps) => {
  const { t } = useTranslation('anychat');
  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm<NoteFormValues>({
    defaultValues: { note: '' },
  });

  const handleFormSubmit = async ({ note }: NoteFormValues) => {
    const success = await onSubmit?.(note.trim());
    if (success) reset();
  };

  return (
    <div
      className={classNames('border-gray-2 border-t bg-white px-4 py-3', {
        'absolute bottom-0 z-30 w-full shrink-0': variant === 'floating',
      })}
    >
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <TextInput
          {...register('note', { validate: (v) => !!v.trim() })}
          placeholder={t('anychat.shared.customerActivityTimeline.note.placeholder')}
          rightSection={
            <Button
              type="submit"
              variant="transparent"
              loading={isSubmitting}
              className="text-link h-auto overflow-hidden px-2 py-0 text-sm font-semibold"
            >
              {t('anychat.chat.notePanel.input.submit')}
            </Button>
          }
          rightSectionWidth={48}
        />
      </form>
    </div>
  );
};
